$(document).ready(function () {

    // Handle minimalize sidebar menu
    $('.hide-menu').on('click', function (event) {
        event.preventDefault();
        $(".logo-administrador").toggleClass('hidden');
    });

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "2500",
        "timeOut": "10000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };

    $('.date-calendar').datetimepicker({
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar',
            up: 'fa fa-chevron-up',
            down: 'fa fa-chevron-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        locale: 'pt-BR',
        sideBySide: false,
        format: 'DD/MM/YYYY',
        timeZone: 'America/Sao_Paulo'
    });

    $('.date-calendar-hour').datetimepicker({
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar',
            up: 'fa fa-chevron-up',
            down: 'fa fa-chevron-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        locale: 'pt-BR',
        sideBySide: false,
        format: 'DD/MM/YYYY HH:mm',
        timeZone: 'America/Sao_Paulo'
    });

    $('.data_calendario_mes').datetimepicker({
        locale: 'pt-BR',
        viewMode: 'months',
        format: 'MM/YYYY',
        timeZone: 'America/Sao_Paulo'
    });

    $('.data_calendario_ano').datetimepicker({
        locale: 'pt-BR',
        viewMode: 'months',
        format: 'YYYY',
        timeZone: 'America/Sao_Paulo'
    });

    $('.input-group.date').datepicker();

    $('.data').mask('00/00/0000');
    $('.codigo').mask('99999999');
    $('.lote').mask('99/99');
    $('.trimestre').mask('9º/9999');
    $('.data_calendario_mes').mask('00/0000');
    $('.cep').mask('00000-000');
    $('.telefone').mask('(99) 9999-9999');
    $('.cpf').mask("000.000.000-00");
    $('.cnpj').mask("00.000.000/0000-00");
    $('.ie').mask("000.000.000.000");
    $('.rg').mask("00.000.009-A", {reverse: true});
    $('.car').mask("SS-0000000.AAAA.AAAA.AAAA.AAAA.AAAA.AAAA.AAAA.AAAA");
    $('.tituloEleitor').mask("0000.0000.0099", {reverse: true});
    $('.celular').focusout(function () {
        var phone, element;
        element = $(this);
        element.unmask();
        phone = element.val().replace(/\D/g, '');
        if (phone.length > 10) {
            element.mask("(99) 99999-9999");
        } else {
            element.mask("(99) 9999-99999");
        }
    }).trigger('focusout');

    var CpfCnpjMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length <= 11 ? '000.000.000-009' : '00.000.000/0000-00';
    };
    var cpfCnpjpOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(CpfCnpjMaskBehavior.apply({}, arguments), options);
        }
    };

    $('.cpfOuCnpj').mask(CpfCnpjMaskBehavior, cpfCnpjpOptions);

    $('.js-source-select2').select2({
        lang: 'pt-BR',
        width: '100%',
        allowClear: true,
        placeholder: {
            id: '',
            text: ''
        }
    }).on("select2:unselect", function (e) {
        $(this).val(null).trigger("change");
    });

    $(".moeda").maskMoney({thousands: '.', decimal: ',', allowZero: false});
    $(".percentual").maskMoney({thousands: '.', decimal: ',', allowZero: false, suffix: '%'});

    $('.text-editor').summernote({
        height: 250,
        lang: 'pt-BR'
    });

    $('.text-editor-simples').summernote({
        height: 300,
        lang: 'pt-BR',
        toolbar: [
            ['headline', ['style']],
            ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
            ['textsize', ['fontsize']],
            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
        ],
        callbacks: {
            onImageUpload: function (data) {
                data.pop();
            }
        }
    });

    $('.text-editor-simples-cliente').summernote({
        height: 190,
        lang: 'pt-BR',
        toolbar: [
            ['headline', ['style']],
            ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
            ['textsize', ['fontsize']],
            ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
        ],
        callbacks: {
            onImageUpload: function (data) {
                data.pop();
            }
        }
    });

    $('.topRow').scrollToFixed({
        marginTop: 62,
        zIndex: 900,
        preFixed: function () {
            $(this).find('.topRow').css('color', 'blue');
        },

    });

    $('.topRowCliente').scrollToFixed({
        preFixed: function () {
            $(this).find('.topRow').css('color', 'blue');
        }
    });

    $(".quantidade-spin").TouchSpin({
        max: 1000000000
    });

    // Initialize iCheck plugin
    $('.i-checks').iCheck({
        checkboxClass: 'icheckbox_square-green',
        radioClass: 'iradio_square-green'
    });

    $('#side-menu-shop').metisMenu({
        toggle: false
    });

    $(document).ready(function () {
        $('.lista-html-simples').DataTable(
            {
                "paging": false,
                "info": false,
                "language": {
                    "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Portuguese-Brasil.json"
                }
            }
        );
    });
});